import { mapGetters } from 'vuex';
import { lockScroll, unlockScroll } from '@/utils/helpers';
import rangeSlider from '@/components/range-slider/range-slider.vue';

export default {
  components: {
    rangeSlider,
  },
  props: {
    value: {
      type: Number,
      default: 50,
    },
    tabindex: Number,
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value !== null ? parseInt(this.value, 10) : 0,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    minimumCentValue() {
      return 1;
    },
    maximumCentValue() {
      return 99;
    },
  },
  watch: {
    val: 'updateOffer',
    value(value) {
      this.val = value !== null ? parseInt(value, 10) : 0;
    },
  },
  methods: {
    add() {
      if (isNaN(this.val) || this.val === null) this.val = this.minimumCentValue;
      this.val += 1;
    },
    subtract() {
      if (isNaN(this.val) || this.val === null) this.val = this.minimumCentValue;
      if (this.val === this.minimumCentValue) return;
      this.val -= 1;
    },
    updateOffer() {
      this.val = parseInt(this.val, 10);
      if (isNaN(this.val) || this.val < 1) this.val = null;
      else if (this.val > 99) this.val = 99;

      if (this.val !== null) {
        this.$emit('input', Number(this.val));
      } else {
        this.$emit('input', this.val);
      }
    },
    click() {
      this.$emit('click');
    },
    onFocus() {
      if (this.isLayoutMobile) {
        lockScroll();
      }
      this.$emit('focus');
      const focusAndSelect = () => {
        const el = this.$refs && this.$refs.input;
        if (el && typeof el.select === 'function') {
          el.focus();
          el.select();
          el.setSelectionRange(0, 99);
        }
      };
      this.$nextTick(focusAndSelect);
      setTimeout(focusAndSelect, 50);
    },
    onBlur() {
      this.$emit('blur', this.val);
      if (this.isLayoutMobile) {
        unlockScroll();
      }
    }
  },
  beforeDestroy() {
    if (this.isLayoutMobile) {
      unlockScroll();
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-offer-value-picker-mobile-sushi/purchase-offer-value-picker-mobile-sushi.js